import { Maintenance } from '@/services/maintenances-service/maintenances-service.types';

export const generateDataSource = (data: Maintenance[]) => {
  return data?.map((element) => ({
    key: element.id,
    ...element,
  }));
};
